<template>

  <div  clearfix class="clearfix main_center">

    <div class="content clearfix">
      <!--Video-->
      <div class="videoPlayerWrapper" :style="{height:videoHeight + 'px'}" >
        <hlsPlayer ref="videoPlayerRef"
                   :videoUrl.sync="videoUrl"
                   :keyIframeOffset.sync="keyIframeOffset"
                   :camDOMid="'camDOMid' + Math.random()"
                   :poster="require('@/assets/images/video_empty.jpg')">
        </hlsPlayer>
        <placeAndEquipment
                ref="placeAndEquipmentRef"
                :showSrcSwitch="true"
                roomType="2"
                :videoSwitchData.sync="videoSrcData"
                @switchCurrentVideo="switchVideoUrl"></placeAndEquipment>
      </div>
        <el-form ref="form" :model="form" style="width:calc(100% - 252px);float: left;margin-top: 12px"  label-width="110px" class="form">
            <el-row>
              <el-col :span="24">
                <el-form-item label="见证记录：" prop='witnessContent' >
                  <el-input type="textarea" disabled :rows="5" v-model="form.witnessContent" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                <el-form-item label="见证人：" prop='witnessUserId' >
                  <el-input   v-model="form.witnessUserName" disabled ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" :offset="1">
                <el-form-item label="开标完成时间：">
                  <el-date-picker
                      v-model="form.bidopenEtime"
                      style="width: 100%"
                      :disabled="true"
                      type="datetime"
                      placeholder="选择时间">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="关键记录："  >
                  <el-table
                          :data="tableDataDetail"
                          border
                          v-loading="keyListLoading"
                          :row-style="{height:60+'px'}"
                          style="width: 100%">
                    <el-table-column
                            header-align="center"
                            label="序号"
                            width="50"
                            type="index"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            header-align="center"
                            label="操作"
                            width="80"
                            align="center">
                      <template slot-scope="scope">
                        <el-button @click="confirmPosition(scope.row.timeDeviationSec,scope.$index)" type="text"  size="small">定位</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column
                            prop="recordTime"
                            header-align="center"
                            label="时间"
                            width="90"
                            align="center">
                      <template scope="scope">
                        <span style="margin-left: 10px" >{{ scope.row.recordTimeStr }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="快照" align="center" width='100'>
                      <template slot-scope="scope">
                        <img :src="scope.row.screenshotUrl" @click="showImgDialog(scope.row.screenshotUrl)" v-if="scope.row.screenshotUrl" class="thumbnail" alt="">
                      </template>
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            header-align="center"
                            label="备注">
                      <template scope="scope">
                        <span style="margin-left: 10px">{{ scope.row.remark }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
        </el-form>
        <div class="baseInfo">
          <p><span class="label">项目名称：</span> <span>{{ project.projectName}}</span></p>
          <p><span class="label">项目编号：</span> <span>{{ project.projectCode}}</span></p>
          <p><span class="label">开标室：</span> <span>{{ project.bidOpenRooms}}</span></p>
          <p><span class="label">招标人：</span> <span>{{ project.tendererName}}</span></p>
          <p><span class="label">联系人：</span> <span>{{ project.tendererLinkMan}}</span></p>
          <p><span class="label">联系电话：</span> <span>{{ project.linkPhone}}</span></p>
          <p><span class="label">招标代理：</span> <span>{{ project.tenderAgencyName}}</span></p>
        </div>
        <div style="clear: both"></div>
    </div>
    <el-dialog :visible.sync="imgDialogVisible" width="100%" height="100%" @closed="dialogClose">
      <img :src="dialogImageUrl" alt="" @contextmenu.prevent=""  class="viewImg">
    </el-dialog>
  </div>





</template>



<script>
    // import videoPlayer from "@/components/videoPlayer/video";
    import videoPlayer from "@/components/videoPlayer/videoXgPlayer";
    import hlsPlayer from "@/components/videoPlayer/hlsPlayer";
    import placeAndEquipment from "@/components/videoPlayer/placeAndEquipment";
    import {tabsCloseCurrentHandle} from '@/utils/routeTab';
    import {scrollToTop} from '@/utils/index';

    export default {
  components: {
    videoPlayer,
    hlsPlayer,
    placeAndEquipment
  },
  data(){
    return{
      imgDialogVisible:false,
      projectListDialog :false,
      bidListDialog: false,
      keyIframeOffset:[],
      dialogImageUrl:"",
      currentVideo:{},
      videoSrcData:[],
      videoHeight:750,
      // videoUrl:"rtmp://58.200.131.2:1935/livetv/cctv1",
      videoUrl:'',
      displayName:'',  //展示在页面的项目名或者标段名
      dateRange:[], //交易起止时间
      form:{    //见证数据
        id: "",          //见证数据ID
        bidopenTime: "", //开标时间
        businessId: "",  //关联的项目ID
        businessexId: "",//关联的标段ID
        createTime: "",  //创建时间
        createUser: "",  //创建人
        dataType: "1",    //见证类型     1专家抽取见证 2开标见证 3评标见证
        delFlag: false,
        detailList: [], //见证明细数据
        evalEtime: "",  //评标结束时间
        evalStime: "",  //评标开始时间
        bidopenEtime:"",//开标结束时间
        field1: "",
        field2: "",
        field3: "",
        fileTypeDictCode: "",
        fileTypeMap: {},
        historyid: "",  //-1:暂存   0:已生效
        remark: "",     //备注
        updateTime: "", //更新时间
        updateUser: "", //更新用户
        videoEtime: "", //视频结束时间
        videoStime: "", //视频开始时间
        witnessContent: "",
        witnessUserId: "",
        dataSource:"",

        bid:{ //标段数据
          id:'',//标段ID
          bidOpenRoomName:"",//开标室名称
          bidOpenRoomCode:""//开标室CODE
        },
      },
      project: {  //项目数据
        id: "",
        bidOpenRoomName:"",
        projectCode: "",   //项目编号
        projectName: "",   //项目名称
        tenderAgencyName: "", //招标代理机构名称
        tendererName:""   //招标人名称
      },
      tableDataDetail: [],  //明细列表
      keyListLoading:false,
      tableDataProject:[],
      tableDataBid:[]
    }


  },
  computed:{

  },

  mounted() {
    this.videoHeight = document.documentElement.clientHeight<600?600:(document.documentElement.clientHeight-125);
  },
  activated() {

    this.form.id = (this.$route.query && this.$route.query.id) || '';
    this.form.dataSource =  (this.$route.query && this.$route.query.dataSource ) || '' ;

    this.getDataById(this.id);
    // 获取见证基本数据
    this.getBaseInfo();
    this.$nextTick(() => {
      if(this.$refs.videoPlayerRef){
        this.$refs.videoPlayerRef.play(); // 播放
      }
    })

  },
  deactivated() {
    console.log("1111111111111:deactivated")
    if(this.$refs.videoPlayerRef){
      this.$refs.videoPlayerRef.pause();  // 暂停
    }
  },
  methods:{
    //定位视频
    confirmPosition(timeDeviationSec) {

      this.$refs.videoPlayerRef.setCurrentTime(timeDeviationSec);
      scrollToTop()

    },

    getBaseInfo(){

      //获取开评标见证数据项目详情
      this.$http.get(`/tradding/traddingwitness/sideInfo?bidCode=${this.form.id}&roomType=2&dataSource=${this.form.dataSource}`).then(res=>{
        if(res.data.code == '1'){
          const data = res.data.data;
          this.project = data || {}
        }
      })


    },

    dialogClose() {
      this.dialogImageUrl = "";
      this.imgDialogVisible = false;
    },
    // 图片放大弹窗
    showImgDialog(filePath){
      this.dialogImageUrl=filePath;
      this.imgDialogVisible = true;
    },

    backBtn(){ //返回
      tabsCloseCurrentHandle();
      this.clearData()
      this.$router.push({
        name:'openBidAndEstimateWitness_list'
      })

    },

    switchVideoUrl(video){

      video.playUrl = video.playUrl?video.playUrl:'';
      video.leavel = video.deviceName || '';
      this.currentVideo = video;
      if(!this.currentVideo.playUrl){
        this.$message({
          type: 'error',
          message: '视频正在合成，请稍后刷新播放'
        })
      }
      this.videoUrl = this.currentVideo.playUrl || '';
      this.getKeyIframeList();


    },
    getKeyIframeList() { // 获取列表数据

      if(this.form.id && this.currentVideo.id){
        this.keyListLoading = true;
           this.$http.get(`/trading/tradingWitDetails/getByWitnessIdAndDeviceCode?witnessId=${this.form.id}&deviceCode=${this.currentVideo.id}&timeDeviation=${this.currentVideo.timeDeviation || 0}`,)
              .then(res=>{
                this.keyListLoading = false;
                if(res.data.code =="1"){
                  this.tableDataDetail = res.data.data;
                  const that = this;
                  var timeOffSetArr = []
                  this.tableDataDetail.forEach((item)=>{
                    // item.screenshotUrl = this.$http.adornUrl(item.screenshotUrl)
                    var timeDeviationSec = parseInt( (new Date(item.recordTime.replace(/-/g,"/")).getTime() - new Date(item.videoStime.replace(/-/g,"/")).getTime() )/1000 ) + (item.timeOffset?parseInt(item.timeOffset):0) ;

                    if(timeDeviationSec >0){
                      item.timeDeviationSec = timeDeviationSec || 0;
                      timeOffSetArr.push(timeDeviationSec);
                      item.recordTimeStr=that.formatterTimeDeviation(timeDeviationSec);
                    }else{
                      item.recordTimeStr = '-:-:-'
                    }

                  })
                  this.keyIframeOffset = timeOffSetArr;
                }else{
                  this.tableDataDetail = [];
                }

              })
      }

    },

    formatterTimeDeviation(timeDeviationSec){

      var hours = parseInt(timeDeviationSec  / 60 / 60 % 24 , 10);
      var minutes = parseInt(timeDeviationSec  / 60 % 60, 10);
      var seconds = parseInt(timeDeviationSec  % 60, 10);
      return (hours<10?('0'+hours):hours) + ":"+ (minutes<10?('0'+minutes):minutes) +':'+ (seconds<10?('0'+seconds):seconds);

    },

    getVideoUrlList(id,bizType,roomType){

      // 查询场地及场地的摄像头
      this.$http.get(`/tradding/traddingwitness/getFieldsAndDevicePlayback?code=${id}&roomType=${roomType}&bizType=${bizType}`).then(res=>{
        if(res.data.code==='1'){

          this.videoSrcData = res.data.data;

          if(this.videoSrcData[0] && this.videoSrcData[0].devices && this.videoSrcData[0].devices[0]){
            const videoObj = JSON.parse(JSON.stringify(this.videoSrcData[0].devices[0]));
            videoObj.playUrl = videoObj.playUrl?videoObj.playUrl:"";
            videoObj.leavel = videoObj.deviceName?videoObj.deviceName:"";
            this.currentVideo=videoObj;
            if(!this.currentVideo.playUrl){
              this.$message({
                type: 'error',
                message: '视频正在合成，请稍后刷新播放'
              })
            }
            this.$refs.placeAndEquipmentRef.setCurrentVideo(this.currentVideo);
            this.getKeyIframeList()
          }
          this.videoUrl = this.currentVideo.playUrl || '';


        }else{
          this.videoSrcData = [];
          this.videoUrl=[];
        }
      })
    },



    getDataById(){ //详情
      if(this.form.id != ""){

        this.$http.get('/tradding/traddingwitness/getOpenEstimateWitness?id='+this.form.id+'&dataType=2').then(res=>{
          if(res.data.code == '1'){
            this.form={...res.data.data};
            // 获取视频源
            this.getVideoUrlList(this.form.businessexId,'bid',2)

          }
        })
      }else {
        this.$router.push({
          name:'openBidAndEstimateWitness_list'
        })
      }

    },


  },


}
</script>

<style lang="less" scoped>
  .viewImg{
    height: 100%;
    display: block;
    margin: 0 auto;
  }
.main_center{
  height: 100%;
  /deep/ .el-dialog__header{
    border-bottom: 0;
  }
  /deep/ .el-dialog__body{
    padding: 0 10px 20px 10px;
  }



  .content{

    .videoPlayerWrapper{
      width: 100%;height:750px;display: block;text-align: center;position: relative
    }


    .thumbnail{
      width: 50px;
      height: 50px;
    }

    .set_btn{
      float:right;
      margin-bottom:20px;
    }
    .more_btn{
      text-align: center;
    }
    .upload-demo{
      display: flex;
      height: 34px;
      border-bottom: 1px solid #dcdfe6;
      .el-button{
        position: absolute;
        right: 0;
      }
    }
  }
}




.backBtn{
  margin-right:10%;
}

  .baseInfo{
    padding:6px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    height: 408px;
    width: 242px;
    float: right;
    margin: 12px 0px;
    p{
      line-height: 20px;
      span.label {
        width: 70px;
        font-weight: 600;
        display: inline-block;
        text-align: right;
        vertical-align: top;
      }
      span:last-child{
        display: inline-block;
        vertical-align: top;
        text-align: left;
        width: 153px;
      }
    }

  }
</style>